/* eslint-disable max-len */
import React from 'react';
// --- external imports ----- 

import { turnSelectors, logbookSelectors } from '~/store';
import { formatCash } from '~/lib/helpers';
import { carSelectors } from '../selectors';
// ---- internal imports ----

const CUSTOM_FAILURE_TEXT_HANDLERS = {
	'getSalesForNMonths': getSalesForNMonths,
	'calculateRatioDifference': calculateRatioDifference,
	'getLeasedCarsStatus': getLeasedCarsStatus,
}

function hasCustomFailureTextHandler(mission) {
	return !!mission?.customFailureTextHandler;
}
function isTimeConstrained(mission) {
	return !!mission?.checkAtStartOfTurn;
}

function didReachCheckingMonth(mission, turnNum) {
	return turnNum === mission.checkAtStartOfTurn
}

function updateFailureTextWithValues(state, missions) {
	let failureTexts = [];
	for (const mission of missions) {
		let text;
		if (hasCustomFailureTextHandler(mission)) {
			text = handleMissionWithCustomFailureTextHandlers(state, mission);
		} else {
			const hasCashValues = mission.failureText.includes('$');
			text = mission.failureText.replace('{value}', hasCashValues ? formatCash(mission?.value): mission?.value);
			text = text.replace('{target}', hasCashValues ? formatCash(mission?.target): mission?.target);
		}

		failureTexts.push(text);
	}

	return failureTexts;
}

function hasMissionFailed(state, mission) {
	const isTimeBounded =  isTimeConstrained(mission);

	if (isTimeBounded) {
		const turnNum = turnSelectors.getTurnNum(state);
		return !mission.completed && turnNum === mission.checkAtStartOfTurn;
	}
	else {
		const hasEvaluatedMission = !!mission?.hasEvaluatedMission;
		return !mission.completed && hasEvaluatedMission;
	}
}

function isMissionCompleted(mission, turnNum) {
	return isTimeConstrained(mission)
		? mission.completed && didReachCheckingMonth(mission, turnNum)
		: mission.completed;
}

function getSalesForNMonths(state, mission) {
	const sales = logbookSelectors.getTotalSalesForLastNMonths(state, 6).reverse();
	let text = mission.failureText;

	for (const sale of sales) {
		text = text.replace('{value}', sale);
	}
	text = text.replace('{target}', mission?.target);
	return text;
}

function calculateRatioDifference(state, mission) {
	const ratioType = mission.metadata?.ratioType;

	const numberOfQuarters = Object.keys(state.financialStatements.systemStatementsByQuarterNum).length
	const previousQuarterFinancialStatements = state.financialStatements.systemStatementsByQuarterNum[numberOfQuarters - 1] ?? null
	const currentQuarterFinancialStatements = state.financialStatements.systemStatementsByQuarterNum[numberOfQuarters] ?? null

	if(!previousQuarterFinancialStatements || !currentQuarterFinancialStatements || !ratioType) {
		return mission.failureText
	}

	let text = mission.failureText;
	const previousRatio = previousQuarterFinancialStatements.financialRatios[ratioType]
	const currentRatio = currentQuarterFinancialStatements.financialRatios[ratioType]
	const difference = ((currentRatio - previousRatio) / previousRatio) * 100;
	text = text.replace('{previous}', previousRatio);
	text = text.replace('{current}', currentRatio);
	text = text.replace('{difference}', difference.toFixed(1));
	return text;
}

function getLeasedCarsStatus(state, mission) {
	const leasedCarsDuringMission = carSelectors.getNumberOfMonthsWithLeasedCarsDuringMission(state, mission);

	if (leasedCarsDuringMission === 0) {
		return "You have not achieved breakeven on a cargo car, because you have not rented one";
	}

	let text = mission.failureText;

	text = text.replace('{numberOfMonths}', leasedCarsDuringMission);
	text = text.replace('{target}', mission?.target);
	text = text.replace('{value}', mission?.value);	
	return text;
}

function handleMissionWithCustomFailureTextHandlers(state, mission) {
	const failureTextHandler = CUSTOM_FAILURE_TEXT_HANDLERS[mission.customFailureTextHandler];

	return failureTextHandler(state, mission);
}

export {
    isMissionCompleted,
    hasMissionFailed,
    updateFailureTextWithValues
};
